namespace $.$$ {
	export class $shm_mentionstat_chart extends $.$shm_mentionstat_chart {
		option() {
			const option = super.option() as ReturnType< $shm_wordstat_chart_timeseries['option'] >
			return {
				...option,
				tooltip: {
					...option.tooltip,
					confine: true,
					enterable: true,
					renderMode: 'html',
					extraCssText: 'box-shadow:none;box-sizing:border-box;max-width:100%;max-height:100%;overflow:auto;white-space:normal;overflow-wrap:anywhere;',
					formatter: ( points: Parameters< $shm_mentionstat_chart['tooltip_content'] >[0] ) => this.tooltip_content( points ),
				},
				legend: {
					...option.legend,
					formatter: ( name: string ) => this.legend_title( name ),
				},
				series: option.series.length && this.total_visible() ? [ {
					...option.series[0],
					name: 'ИТОГО',
					data: option.xAxis.data.map( ( _, index ) =>
						option.series.reduce( ( total, series ) => total + series.data[index], 0 )
					),
				}, ...option.series ] : option.series,
			}
		}

		legend_title( name: string ) {
			const chars = Array.from( name )
			return chars.length > 30 ? chars.slice( 0, 29 ).join( '' ) + '…' : name
		}

		tooltip_content( points: readonly { seriesName: string, value: number, axisValueLabel?: string, marker?: string }[] ) {
			if( !points.length ) return ''
			const title = $mol_html_encode( points[0].axisValueLabel ?? '' ).replaceAll( '\n', '<br>' )
			const rows = [ ...points ].sort( ( left, right ) => right.value - left.value ).map( point =>
				`${ point.marker ?? '' }${ $mol_html_encode( this.legend_title( point.seriesName ) ) }: ${ point.value.toLocaleString( 'ru-RU' ) }`
			)
			return `<div role="tooltip">${ [ title, ...rows ].join( '<br>' ) }</div>`
		}

		group_options() {
			return {
				day: 'По дням',
				week: 'По неделям',
				month: 'По месяцам',
				year: 'По годам',
			}
		}

		group_period_kind() {
			if( this.group() === 'week' ) return 'PERIOD_WEEKLY'
			if( this.group() === 'month' || this.group() === 'year' ) return 'PERIOD_MONTHLY'
			return 'PERIOD_DAILY'
		}

		date_title( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			if( !match ) return date
			if( this.group() === 'year' ) return match[1]
			if( this.group() === 'month' ) return `${ match[2] }.${ match[1] }`
			if( this.group() === 'week' ) {
				const interval = this.date_interval( date )
				return `${ this.date_title_day( interval.from ) }\n- ${ this.date_title_day( interval.to ) }`
			}
			return this.date_title_day( date )
		}

		date_interval( date: string ) {
			const from = String( date ).slice( 0, 10 )
			if( this.group() === 'year' ) return { from: `${ from.slice( 0, 4 ) }-01-01`, to: `${ from.slice( 0, 4 ) }-12-31` }
			if( this.group() === 'month' ) return {
				from,
				to: this.date_shift( from, value => {
					value.setUTCMonth( value.getUTCMonth() + 1 )
					value.setUTCDate( 0 )
				} ),
			}
			if( this.group() === 'week' ) return {
				from,
				to: this.date_shift( from, value => value.setUTCDate( value.getUTCDate() + 6 ) ),
			}
			return { from, to: from }
		}

		date_title_day( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : date
		}

		date_shift( date: string, shift: ( value: Date )=> void ) {
			const value = new Date( `${ date.slice( 0, 10 ) }T00:00:00Z` )
			if( Number.isNaN( value.getTime() ) ) return date
			shift( value )
			return value.toISOString().slice( 0, 10 )
		}
	}
}
